var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Send_Button",
    "data-name": "Send Button",
    transform: "translate(-0.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2321",
    "data-name": "Group 2321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2293",
    "data-name": "Group 2293"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_326",
    "data-name": "Ellipse 326",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(0.372)",
    fill: "#03f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M79.676,32.752l18.535-8.376L79.676,16l-.009,7.515,8.8.861-8.8.861Z",
    transform: "translate(-69.47 -7)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.53a66f63f7e2644ac9aca3fe322927d5.svg";
export { ForwardRef as ReactComponent };